// Cali Move Mobility — full program data, expanded into phases > weeks > days.
const ex = (name, sets, reps = null, hold = null) => ({ name, sets, reps, hold });

// Mastery-path exercises (Mobilità & Rinforzo) — enriched schema
const exm = (name, sets, reps, hold, opts = {}) => ({
  name,
  sets,
  reps,
  hold,
  desc: opts.desc || null, // a cosa serve (stringa)
  cues: opts.cues || [], // come eseguirlo (array di stringhe)
  errors: opts.errors || [], // errori da evitare (array di stringhe)
  keyId: opts.keyId || null, // se valorizzato => movimento chiave
  criteria: opts.criteria || null, // solo per i chiave: { pain, control, quality }
  images: opts.images || [],
});

const WEEKDAYS = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"];

// ---------------------------------------------------------------------------
// Exercise blocks
// ---------------------------------------------------------------------------
const PREP_A = [
  ex("Deep Squat Wrist Circles", 2, 4),
  ex("Knee Sit Wrist Circles", 1, 2),
  ex("Wrist Flexion", 1, 4, 2),
  ex("Cat Cow", 1, 4, 1),
  ex("Sitting Hip Rotations", 1, 4, 3),
  ex("Deep Squat Reach", 1, 3, 3),
  ex("Archer Squat", 1, 3, 3),
];
const PREP_B = [
  ex("Lunge Stance Rotations", 1, 2),
  ex("Easy Bridge / Pike Sit", 1, 3, 2),
  ex("Jefferson Curl", 2, 3),
  ex("Passive Hang", 2, null, 20),
  ex("Stick Shoulder Disloc", 2, 4),
  ex("Stick Shoulder Extension", 2, 4, 3),
  ex("Ostrich Walk", 2, 8),
];

const L1_B1 = [
  ex("Deep Squat Wrist Circles", 2, 4),
  ex("Lunge Stance Rotations", 1, 2),
  ex("Knee Sit Wrist Circles", 1, 2),
  ex("Easy Bridge / Pike Sit", 1, 3, 2),
  ex("Wrist Flexion", 1, 4, 2),
  ex("Jefferson Curl", 2, 3),
  ex("Cat Cow", 1, 4, 1),
  ex("Passive Hang", 2, null, 20),
  ex("Sitting Hip Rotations", 1, 4, 3),
  ex("Stick Shoulder Disloc", 2, 4),
  ex("Deep Squat Reach", 1, 3, 3),
  ex("Stick Shoulder Extension", 2, 4, 3),
  ex("Archer Squat", 1, 3, 3),
  ex("Ostrich Walk", 2, 8),
];
const L1_B2 = [
  ex("Deep Squat Wrist Circles", 3, 4),
  ex("Lunge Stance Rotations", 1, 3),
  ex("Knee Sit Wrist Circles", 1, 3),
  ex("Easy Bridge / Pike Sit", 1, 4, 2),
  ex("Wrist Flexion", 1, 6, 2),
  ex("Jefferson Curl", 2, 4),
  ex("Cat Cow", 1, 6, 1),
  ex("Passive / Active Hang", 3, 4),
  ex("Sitting Hip Rotations", 1, 6, 3),
  ex("Stick Shoulder Disloc", 2, 5),
  ex("Deep Squat Reach", 1, 4, 3),
  ex("Stick Shoulder Extension", 2, 6, 3),
  ex("Archer Squat", 2, 6, 3),
  ex("Ostrich Walk", 2, 10),
];
const L1_B3 = [
  ex("Deep Squat Wrist Circles", 3, 6),
  ex("Lunge Stance Rotations", 2, 3),
  ex("Knee Sit Wrist Circles", 1, 4),
  ex("Easy Bridge / Pike Sit", 1, 4, 3),
  ex("Wrist Flexion", 2, 6, 2),
  ex("Jefferson Curl", 3, 4),
  ex("Cat Cow", 2, 5, 2),
  ex("Passive / Active Hang", 3, 6),
  ex("Sitting Hip Rotations", 2, 5, 3),
  ex("Stick Shoulder Disloc", 3, 5),
  ex("Deep Squat Reach", 2, 4, 3),
  ex("Stick Shoulder Extension", 3, 5, 5),
  ex("Archer Squat", 2, 4, 3),
  ex("Ostrich Walk", 3, 10),
];

const L2_B1 = [
  ex("Knee Stance Flow", 1, 3),
  ex("Lunge Stance Rotations", 1, 4),
  ex("Quadruped Wrist Circles", 1, 2),
  ex("Easy Bridge Routine", 1, 4, 2),
  ex("Quadruped Wrist Flexion", 1, 4, 2),
  ex("Sitting Leg Raise", 1, 4, 1),
  ex("Advanced Cat Cow", 1, 4, 1),
  ex("Jefferson Curl", 2, 3),
  ex("Pike Stand Heel Lift", 1, 4, 1),
  ex("Passive / Active Hang", 3, 8, 1),
  ex("Lunge and Reach", 1, 4, 2),
  ex("Lateral Monkey", 2, 4),
  ex("Shaolin Sit", 1, 4, 2),
  ex("Deep Squat Walk", 2, 4),
  ex("Deep Squat Reach", 1, 3, 3),
  ex("Caterpillar Press", 2, 4),
  ex("Squat Hip Rotations", 1, 4, 1),
  ex("Lying Stick Shoulder Disloc", 2, 4),
  ex("Archer Squat Routine", 1, 2, 1),
  ex("Stick Shoulder Extension", 3, 5, 3),
];
const L2_B2 = [
  ex("Knee Stance Flow", 1, 4),
  ex("Lunge Stance Rotations", 1, 4),
  ex("Quadruped Wrist Circles", 1, 3),
  ex("Easy Bridge Routine", 1, 6, 3),
  ex("Quadruped Wrist Flexion", 1, 6, 2),
  ex("Sitting Leg Raise", 2, 4, 2),
  ex("Advanced Cat Cow", 1, 6, 1),
  ex("Jefferson Curl", 3, 4),
  ex("Pike Stand Heel Lift", 1, 6, 1),
  ex("Archer Scapula Raise", 2, 4, 1),
  ex("Lunge and Reach", 1, 6, 2),
  ex("Lateral Monkey", 2, 6),
  ex("Shaolin Sit", 2, 4, 2),
  ex("Deep Squat Walk", 2, 6),
  ex("Deep Squat Reach", 1, 5, 3),
  ex("Caterpillar Press", 2, 6),
  ex("Squat Hip Rotations", 1, 6, 2),
  ex("Lying Stick Shoulder Disloc", 2, 6),
  ex("Archer Squat Routine", 1, 4, 3),
  ex("Stick Shoulder Extension", 3, 6, 5),
];
const L2_B3 = [
  ex("Knee Stance Flow", 2, 3),
  ex("Lunge Stance Rotations", 2, 4),
  ex("Quadruped Wrist Circles", 1, 4),
  ex("Easy Bridge Routine", 2, 4, 3),
  ex("Quadruped Wrist Flexion", 2, 4, 2),
  ex("Sitting Leg Raise", 3, 4, 3),
  ex("Advanced Cat Cow", 2, 4, 2),
  ex("Jefferson Curl", 3, 5),
  ex("Pike Stand Heel Lift", 2, 4, 2),
  ex("Archer Scapula Raise", 3, 6, 2),
  ex("Lunge and Reach", 2, 4, 4),
  ex("Lateral Monkey", 3, 5),
  ex("Shaolin Sit", 2, 6, 3),
  ex("Deep Squat Walk", 3, 5),
  ex("Deep Squat Reach", 2, 4, 3),
  ex("Caterpillar Press", 3, 5),
  ex("Squat Hip Rotations", 2, 4, 3),
  ex("Lying Stick Shoulder Disloc", 3, 5),
  ex("Archer Squat Routine", 2, 3, 3),
  ex("Stick Shoulder Extension", 3, 7, 7),
];

const L3_B1 = [
  ex("Adv. Knee Stance Flow", 1, 2),
  ex("Prying Goblet Squat", 1, 4),
  ex("Plank Wrist Circles", 1, 2),
  ex("Easy Bridge Translation", 2, 4, 3),
  ex("Quadruped Wrist Flexion", 1, 4, 2),
  ex("Easy to Back Bridge", 1, 2, 1),
  ex("Pushup Shrugs", 1, 4, 1),
  ex("Sitting Leg Raise", 3, 4, 4),
  ex("Pike Stand Heel Lift", 2, 4, 3),
  ex("Backbridge Push Ups", 1, 2, 1),
  ex("Lunge Foot Circles", 1, 2),
  ex("Weighted Jefferson Curl", 2, 3),
  ex("Adv. Lunge and Reach", 1, 3, 3),
  ex("Archer Scap Raise", 3, 8, 2),
  ex("Shaolin Sit Leg Raise", 1, 2, 1),
  ex("Adv. Lateral Monkey", 2, 4),
  ex("Fig. 4 Squat Rotations", 2, 2),
  ex("Deep Squat Walk", 1, 4),
  ex("Adv. Deep Squat Reach", 2, 4, 3),
  ex("Backbridge Walk", 1, 4),
  ex("Archer Squat Routine", 2, 3, 4),
  ex("Hurdle Sit Switches", 1, 2, 2),
  ex("Lying Stick Shoulder Disloc", 2, 4),
  ex("Stick Shoulder Extension", 3, 5, 5),
];
const L3_B2 = [
  ex("Adv. Knee Stance Flow", 1, 3),
  ex("Prying Goblet Squat", 2, 4),
  ex("Plank Wrist Circles", 2, 2),
  ex("Easy Bridge Translation", 2, 4, 5),
  ex("Quadruped Wrist Flexion", 1, 5, 3),
  ex("Easy to Back Bridge", 1, 3, 2),
  ex("Pushup Shrugs", 1, 6, 1),
  ex("Sitting Leg Raise", 3, 4, 6),
  ex("Pike Stand Heel Lift", 2, 5, 3),
  ex("Backbridge Push Ups", 2, 3, 2),
  ex("Lunge Foot Circles", 2, 2),
  ex("Weighted Jefferson Curl", 2, 4),
  ex("Adv. Lunge and Reach", 2, 4, 3),
  ex("One Arm Scap Raise", 2, 2, 2),
  ex("Shaolin Sit Leg Raise", 2, 3, 1),
  ex("Adv. Lateral Monkey", 2, 6),
  ex("Fig. 4 Squat Rotations", 2, 3),
  ex("Deep Squat Walk", 3, 8),
  ex("Adv. Deep Squat Reach", 3, 4, 3),
  ex("Backbridge Walk", 2, 5),
  ex("Archer Squat Routine", 2, 3, 2),
  ex("Hurdle Sit Switches", 2, 5, 2),
  ex("Lying Stick Shoulder Disloc", 2, 6),
  ex("Stick Shoulder Extension", 3, 8, 10),
];
const L3_B3 = [
  ex("Adv. Knee Stance Flow", 2, 2),
  ex("Prying Goblet Squat", 2, 5),
  ex("Plank Wrist Circles", 2, 3),
  ex("Easy Bridge Translation", 3, 4, 5),
  ex("Quadruped Wrist Flexion", 2, 4, 3),
  ex("Easy to Back Bridge", 2, 3, 4),
  ex("Pushup Shrugs", 2, 5, 2),
  ex("Sitting Leg Raise", 3, 5, 6),
  ex("Pike Stand Heel Lift", 3, 4, 3),
  ex("Backbridge Push Ups", 2, 4, 3),
  ex("Lunge Foot Circles", 2, 3),
  ex("Weighted Jefferson Curl", 3, 4),
  ex("Adv. Lunge and Reach", 2, 5, 3),
  ex("One Arm Scap Raise + Rot.", 3, 3, 3),
  ex("Shaolin Sit Leg Raise", 2, 3, 2),
  ex("Adv. Lateral Monkey", 2, 8),
  ex("Fig. 4 Squat Rotations", 3, 3),
  ex("Deep Squat Walk", 4, 8),
  ex("Adv. Deep Squat Reach", 3, 5, 3),
  ex("Backbridge Walk", 3, 6),
  ex("Archer Squat Routine", 3, 4, 4),
  ex("Hurdle Sit Switches", 2, 4, 3),
  ex("Lying Stick Shoulder Disloc", 3, 5),
  ex("Stick Shoulder Extension", 4, 5, 10),
];

// ---------------------------------------------------------------------------
// Weekly schedules: arrays of 8 weeks, each an array of 7 day-numbers or null
// ---------------------------------------------------------------------------
const L1_SCHED = [
  [1, null, 3, null, 5, null, null],
  [8, null, 10, null, 12, null, null],
  [15, null, 17, null, 19, null, null],
  [22, null, 24, null, 26, null, null],
  [29, null, 31, null, 33, null, 35],
  [null, 37, null, 39, null, 41, null],
  [43, null, 45, null, 47, null, 49],
  [null, 51, null, 53, null, 55, null],
];
const L2_SCHED = [
  [1, null, 3, null, 5, null, 7],
  [8, null, 10, null, 12, null, 14],
  [15, null, 17, null, 19, null, 21],
  [22, null, 24, null, 26, null, 28],
  [29, 30, 31, null, 33, 34, null],
  [36, 37, 38, null, 40, 41, null],
  [43, 44, 45, null, 47, 48, null],
  [50, 51, 52, null, 54, 55, null],
];
const L3_SCHED = [
  [1, 2, 3, null, 5, 6, null],
  [8, 9, 10, null, 12, 13, null],
  [15, 16, 17, null, 19, 20, null],
  [22, 23, 24, null, 26, 27, null],
  [29, 30, 31, null, 33, 34, 35],
  [36, 37, 38, null, 40, 41, 42],
  [43, 44, 45, null, 47, 48, 49],
  [50, 51, 52, null, 54, 55, 56],
];

function blockForWeek(weekIdx, b1, b2, b3) {
  if (weekIdx <= 1) return b1;
  if (weekIdx <= 5) return b2;
  return b3;
}

function buildLevel(id, name, schedule, b1, b2, b3) {
  const weeks = schedule.map((days, wi) => {
    const block = blockForWeek(wi, b1, b2, b3);
    return {
      id: `${id}-w${wi + 1}`,
      name: `Settimana ${wi + 1}`,
      days: days.map((dayNum, di) => {
        if (dayNum == null) {
          return { type: "rest", weekday: WEEKDAYS[di] };
        }
        return {
          type: "training",
          id: `${id}-d${dayNum}`,
          dayNum,
          weekday: WEEKDAYS[di],
          label: `Giorno ${dayNum}`,
          exercises: block,
        };
      }),
    };
  });
  return { id, name, weeks };
}

// Preparation week
const PREP_DAYS = [
  { type: "training", id: "prep-d1", dayNum: 1, weekday: "Lun", label: "Giorno 1", exercises: PREP_A },
  { type: "training", id: "prep-d2", dayNum: 2, weekday: "Mar", label: "Giorno 2", exercises: PREP_B },
  { type: "training", id: "prep-d3", dayNum: 3, weekday: "Mer", label: "Giorno 3", exercises: PREP_A },
  { type: "training", id: "prep-d4", dayNum: 4, weekday: "Gio", label: "Giorno 4", exercises: PREP_B },
  { type: "training", id: "prep-d5", dayNum: 5, weekday: "Ven", label: "Giorno 5", exercises: PREP_A },
  { type: "training", id: "prep-d6", dayNum: 6, weekday: "Sab", label: "Giorno 6", exercises: PREP_B },
  { type: "rest", weekday: "Dom" },
];

const CALIMOVE = {
  id: "calimove",
  name: "Mobility Program",
  private: true,
  allowedEmails: ["paoloc2910@gmail.com"],
  progressionType: "calendar",
  phases: [
    {
      id: "prep",
      name: "Preparazione",
      subtitle: "Settimana 0",
      tag: "Inizia qui",
      weeks: [{ id: "prep-w0", name: "Settimana 0", days: PREP_DAYS }],
    },
    { id: "level1", name: "Livello 1", subtitle: "Settimane 1–8", tag: "Base", ...buildLevel("level1", "Livello 1", L1_SCHED, L1_B1, L1_B2, L1_B3) },
    { id: "level2", name: "Livello 2", subtitle: "Settimane 9–16", tag: "Intermedio", ...buildLevel("level2", "Livello 2", L2_SCHED, L2_B1, L2_B2, L2_B3) },
    { id: "level3", name: "Livello 3", subtitle: "Settimane 17–24", tag: "Avanzato", ...buildLevel("level3", "Livello 3", L3_SCHED, L3_B1, L3_B2, L3_B3) },
  ],
  bonus: [
    {
      id: "front-split",
      name: "Front Split",
      desc: "Mobilità per la spaccata frontale",
      exercises: [
        ex("Pre Front Split", 2, 1, 120),
        ex("Wall Quad Hip Flexor Stretch", 2, 2, 120),
        ex("Standing Leg Raise", 3, 5, 10),
      ],
    },
    {
      id: "side-split",
      name: "Side Split",
      desc: "Mobilità per la spaccata laterale",
      exercises: [
        ex("Pre Side Split", 2, 1, 120),
        ex("Horse Stance", 3, 5, 30),
        ex("Standing Side Leg Raise", 3, 3, 10),
      ],
    },
    {
      id: "vsit-handstand",
      name: "V-Sit & Handstand Press",
      desc: "Mobilità per V-Sit e Handstand Press",
      exercises: [
        ex("Sitting Pike Stretch", 2, 1, 120),
        ex("Sitting Leg Raise", 3, 8, 8),
        ex("Wall V-Sit", 3, 3, 10),
        ex("Weighted Jefferson Curl", 3, 3, 10),
        ex("Weight. St. Shoulder Extension", 4, 8, 10),
        ex("Lying Weighted Stick Lift", 3, 3, 10),
      ],
    },
  ],
};

// ---------------------------------------------------------------------------
// Program registry (multi-program support)
// ---------------------------------------------------------------------------
// ---------------------------------------------------------------------------
// Mobilità & Rinforzo — Stadio 1 (mastery path)
// ---------------------------------------------------------------------------
const MR_L1_A = [
  exm("Respirazione diaframmatica", 2, 6, null, {
    desc: "Resetta il tono dei muscoli profondi del core (diaframma e trasverso) e riattiva il respiro addominale. È la base per stabilizzare la colonna sotto carico: senza questo, tutto il resto poggia sul vuoto.",
    cues: [
      "Supino, ginocchia piegate, piedi a terra",
      "Una mano sul petto, una sull'ombelico",
      "Inspira dal naso gonfiando la pancia: sale la mano sull'ombelico, ferma quella sul petto",
      "Espira lungo e lento dalla bocca svuotando del tutto (4 sec dentro, 6 fuori)",
    ],
    errors: [
      "Gonfiare il petto e le spalle invece della pancia",
      "Trattenere il respiro",
      "Irrigidire collo e mascella",
      "Accorciare l'espirazione",
    ],
  }),
  exm("Cat-cow segmentale", 1, 6, null, {
    desc: "Mobilità della colonna in flesso-estensione, eseguita vertebra per vertebra invece che a blocco unico. Recupera il controllo fine di ogni tratto e lubrifica le articolazioni a carico zero. È anche il modo migliore per sentire quali tratti della schiena sono rigidi.",
    cues: [
      "Quadrupedia, mani sotto le spalle e ginocchia sotto i fianchi, schiena piatta",
      "Gatto: arrotonda dal coccige, poi lombare, poi dorsale, testa per ultima",
      "Mucca: inverti dal basso, coccige su, lombare giù, petto aperto, sguardo per ultimo",
      "3-4 sec a fase, espira nel gatto, inspira nella mucca",
    ],
    errors: [
      "Muovere la schiena come un blocco rigido invece che segmento per segmento",
      "Forzare l'inarcamento spingendo solo dalla lombare",
      "Spalle che salgono verso le orecchie",
      "Andare veloce o a scatti",
    ],
    images: ["/exercises/cat-cow-1.jpg", "/exercises/cat-cow-2.jpg"],
  }),
  exm("Glute bridge", 3, 8, null, {
    keyId: "glutebridge",
    desc: "Attiva i glutei e insegna a estendere l'anca senza caricare la zona lombare — mattone fondamentale per la salute della schiena. Trasferisce il lavoro dove deve stare (glutei) togliendolo da dove crea problemi (lombare).",
    cues: [
      "Supino, piedi a terra vicino ai glutei, larghezza dei fianchi",
      "Spingi dai talloni",
      "Solleva il bacino finché il corpo è in linea dalle ginocchia alle spalle",
      "Stringi i glutei in cima per 2 secondi, poi scendi lento",
    ],
    errors: [
      "Inarcare la schiena per salire più in alto (deve estendere l'anca, non la colonna)",
      "Spingere dalle punte invece che dai talloni",
      "Salire a strappo",
      "Non stringere i glutei (si sente nei femorali o nella schiena)",
    ],
    criteria: {
      pain: "Nessun fastidio lombare durante o dopo; la spinta si sente nei glutei, non nella schiena.",
      control: "8 ripetizioni con 2 secondi di tenuta in alto, bacino stabile e a livello.",
      quality: "Corpo in linea retta (no iperestensione), spinta dai talloni, glutei attivi, nessun compenso lombare.",
    },
    images: ["/exercises/glute-bridge-1.jpg", "/exercises/glute-bridge-2.jpg"],
  }),
  exm("Dead bug", 3, 6, null, {
    keyId: "deadbug",
    desc: "Insegna al core a tenere ferma la colonna mentre braccia e gambe si muovono — ciò che serve nella vita reale per proteggere la schiena. Lavora la stabilità anti-estensione: la lombare resta a terra, non si inarca. (6 ripetizioni per lato)",
    cues: [
      "Supino, braccia verso il soffitto, fianchi e ginocchia a 90°",
      "Schiaccia la lombare a terra e tienila lì per tutto l'esercizio",
      "Abbassa lentamente braccio e gamba opposti, sfiora il pavimento senza toccarlo, poi torna",
      "Alterna i lati, respira normalmente",
    ],
    errors: [
      "La schiena che si stacca da terra e si inarca (se succede, riduci il range)",
      "Trattenere il respiro",
      "Andare veloce perdendo il controllo",
      "Estendere gli arti oltre quanto il core riesce a controllare",
    ],
    criteria: {
      pain: "Zero dolore lombare; la fatica si sente nell'addome profondo.",
      control: "6 ripetizioni per lato mantenendo la lombare aderente a terra per tutta la serie.",
      quality: "Schiena che non si inarca mai, movimento lento e controllato, respiro continuo, arti opposti coordinati.",
    },
    images: ["/exercises/dead-bug-1.jpg"],
  }),
  exm("Wall slide scapolare", 2, 8, null, {
    keyId: "wallslide",
    desc: "Riattiva i muscoli che stabilizzano le scapole e contrasta la postura ingobbita da scrivania e telefono. Recupera la mobilità delle spalle in elevazione senza compensare con la schiena.",
    cues: [
      "In piedi con schiena, bacino e testa appoggiati al muro; i PIEDI stanno a circa 15-20 cm dalla parete, leggermente in avanti",
      "Piega leggermente le ginocchia e appiattisci la zona lombare contro il muro (non deve restare spazio dietro la schiena bassa)",
      "Porta le braccia contro il muro a formare una W: dorso delle mani e gomiti a contatto con la parete",
      "Fai scivolare le braccia verso l'alto fino a una Y, mantenendo mani e gomiti attaccati al muro",
      "Torna giù lento, controllando il movimento",
    ],
    errors: [
      "La schiena bassa che si stacca dal muro e si inarca per far salire le braccia",
      "Gomiti o polsi che perdono il contatto col muro",
      "Spalle che salgono verso le orecchie",
      "Forzare l'altezza sacrificando il contatto",
    ],
    criteria: {
      pain: "Nessun dolore o impingement alla spalla; lavoro percepito tra le scapole.",
      control: "8 ripetizioni mantenendo mani, gomiti e lombare in contatto col muro.",
      quality: "Schiena bassa piatta sul muro, contatto delle braccia mantenuto, spalle basse, movimento simmetrico.",
    },
  }),
  exm("Mobilità caviglia (knee-to-wall)", 2, 8, null, {
    desc: "Sblocca la dorsiflessione della caviglia. Caviglie rigide costringono ginocchia e schiena a compensare in squat, affondi e nell'accovacciarsi: liberarle a monte protegge le articolazioni sopra. Spesso è il vero collo di bottiglia nascosto. (8 ripetizioni per lato)",
    cues: [
      "In ginocchio su una gamba, piede davanti a pochi cm dal muro",
      "Spingi il ginocchio in avanti a toccare il muro tenendo il tallone a terra",
      "Se tocca facile, allontana il piede e riprova; cerca il punto in cui il tallone sta per staccarsi",
      "Movimento lento, niente rimbalzi",
    ],
    errors: [
      "Il tallone che si solleva da terra (annulla l'esercizio)",
      "Il ginocchio che cade verso l'interno invece di andare dritto sopra le dita",
      "Rimbalzare invece di tenere il controllo",
      "Spingere nel dolore articolare anteriore",
    ],
  }),
];

const MR_L1_B = [
  exm("Respirazione 90/90", 2, 6, null, {
    desc: "Variante del respiro diaframmatico con gambe sollevate su un appoggio, fianchi e ginocchia a 90°. Porta il bacino in retroversione e spegne la lombare iperattiva, rendendo più facile sentire il core profondo. Reset ideale prima del lavoro sul pattern d'anca.",
    cues: [
      "Supino, polpacci appoggiati su una sedia/divano, fianchi e ginocchia a 90°",
      "Lombare che si appoggia naturalmente a terra",
      "Inspira dal naso nella pancia",
      "Espira lungo sentendo le costole che scendono; non spingere la schiena, lasciala posarsi",
    ],
    errors: [
      "Inarcare la lombare staccandola da terra",
      "Respirare di petto",
      "Tendere il collo",
      "Alzare le spalle a ogni inspirazione",
    ],
  }),
  {
    name: "Mobilità anca da seduto (90/90)",
    sets: 1, reps: 6, hold: null,
    progressionId: "mr-l1-ancaseduto",
    variants: [
      {
        name: "Tergicristallo da seduto",
        desc: "Il punto di partenza. Da seduto, fai oscillare le ginocchia da un lato all'altro come un tergicristallo: apri la rotazione dell'anca in modo dolce, controllando tu quanto scendere. (oscillazioni lente, ~6 per lato)",
        cues: [
          "Seduto a terra, piedi piantati davanti poco più larghi dei fianchi, ginocchia a ~90°",
          "Mani appoggiate a terra dietro o di fianco per sostenerti, petto alto",
          "Lascia cadere entrambe le ginocchia insieme verso un lato, fin dove sei comodo, poi torna al centro e vai dall'altro",
          "Lento e controllato: all'inizio non serve toccare terra",
        ],
        errors: [
          "Buttarsi giù di slancio invece di controllare",
          "Arrotondare la schiena",
          "Sollevare i piedi da terra (restano piantati)",
          "Forzare oltre il punto comodo",
        ],
        unlockLabel: "Riesco a far scendere le ginocchia quasi a terra da entrambi i lati, comodo e senza dolore",
        images: ["/exercises/tergicristallo-1.jpg"],
      },
      {
        name: "90/90 con rialzo",
        desc: "Il ponte verso la posizione piena. Stessa rotazione, ma da seduto in posizione 90/90 con un rialzo sotto i glutei che rende tutto più accessibile. (6 rotazioni per lato)",
        cues: [
          "Siediti su un rialzo sotto ENTRAMBI i glutei (cuscino, libro spesso, tappetino piegato) così il bacino resta piano e simmetrico",
          "Gambe in posizione a Z: una davanti e una di lato, entrambe a ~90°",
          "Appoggia le mani a terra per sostenerti; tieni la gamba dietro un po' più aperta se serve",
          "Ruota lentamente le ginocchia da un lato all'altro passando per il centro, restando comodo",
        ],
        errors: [
          "Rialzo troppo basso (il bacino si solleva e ti sbilanci)",
          "Mettere il rialzo sotto un solo fianco invece che sotto entrambi i glutei",
          "Schiena curva",
          "Ruotare a strappi",
        ],
        unlockLabel: "Ruoto comodo anche con un rialzo basso, senza dover spingere sulle mani",
        images: ["/exercises/anca-9090-pieno.jpg"],
      },
      {
        name: "90/90 pieno",
        desc: "La versione completa. Seduto in 90/90 senza rialzo (o minimo), busto eretto e mani libere, ruoti le ginocchia da lato a lato controllando andata e ritorno. (6 rotazioni per lato)",
        cues: [
          "Seduto a terra, gambe a Z (una davanti, una di lato, entrambe a 90°), busto eretto",
          "Ruota attivamente entrambe le ginocchia da un lato all'altro passando per il centro",
          "Pausa di un secondo nei due estremi, petto sempre alto",
          "Vai solo fin dove controlli, senza buttarti",
        ],
        errors: [
          "Arrotondare la schiena per arrivare più giù",
          "Forzare il range a strappi",
          "Sollevare il bacino invece di muovere le anche",
          "Trattenere il respiro nello sforzo",
        ],
        images: ["/exercises/anca-9090-pieno.jpg"],
      },
    ],
  },
  exm("Hip hinge a corpo libero", 3, 6, null, {
    keyId: "hiphinge",
    desc: "Il pattern motorio più importante per la salute della schiena: piegarsi DALL'ANCA mandando il bacino indietro, mentre la colonna resta neutra. È il gesto per raccogliere qualsiasi cosa da terra per il resto della vita, ed è la fondazione di stacchi e squat negli stadi avanzati.",
    cues: [
      "In piedi, piedi a larghezza dei fianchi, ginocchia morbide (non bloccate, non piegate)",
      "Immagina di chiudere una portiera dietro di te col sedere: il bacino va INDIETRO, non in giù",
      "Busto che si inclina in avanti restando dritto come un'asse; senti l'allungamento dietro le cosce",
      "Risali spingendo il bacino in avanti e stringendo i glutei",
      "Usa un bastone (o un manico di scopa) per imparare: tienilo verticale lungo la schiena, deve toccare testa, dorso e sacro. Questi tre punti non devono mai perdere il contatto durante il movimento: se il bastone si stacca in un punto, la schiena si sta arrotondando",
    ],
    errors: [
      "Arrotondare la schiena invece di tenerla neutra (l'errore che causa infortuni — se la schiena si curva, fermati)",
      "Piegare le ginocchia come in uno squat invece di mandare l'anca indietro",
      "Guardare in alto strappando il collo",
      "Scendere più di quanto i femorali permettano senza arrotondare",
    ],
    criteria: {
      pain: "Zero dolore lombare durante e nelle ore dopo; senti l'allungamento dietro le cosce, non fastidio nella schiena.",
      control: "6 ripetizioni lente, 3 secondi in discesa, mantenendo il pattern stabile.",
      quality: "Schiena neutra che non si arrotonda mai, il movimento parte dall'anca, peso sui talloni, collo in linea con la colonna.",
    },
    images: ["/exercises/hip-hinge-1.jpg", "/exercises/hip-hinge-2.jpg"],
  }),
  exm("Bird dog", 3, 6, null, {
    desc: "Allena la stabilità anti-rotazione del core e la coordinazione crociata braccio-gamba, mentre la colonna resta ferma. Completa il dead bug allenando lo stesso controllo in quadrupedia, posizione più vicina ai gesti reali. (6 ripetizioni per lato)",
    cues: [
      "Quadrupedia, schiena piatta come un tavolo",
      "Estendi braccio e gamba opposti fino all'orizzontale",
      "Immagina un bicchiere d'acqua sulla schiena che non deve rovesciarsi: niente rotazioni del bacino",
      "Tieni 2 secondi, torna controllato, alterna; sguardo a terra, collo neutro",
    ],
    errors: [
      "Il bacino che ruota o si inclina quando sollevi la gamba",
      "Inarcare la lombare alzando il braccio",
      "Alzare la gamba sopra l'orizzontale cercando altezza",
      "Perdere l'equilibrio per andare troppo veloce",
    ],
    images: ["/exercises/bird-dog-1.jpg"],
  }),
  exm("Glute bridge", 3, 8, null, {
    keyId: "glutebridge",
    desc: "Ritorna in Sessione B per frequenza: l'estensione d'anca è un mattone che ripaga la ripetizione, e ti dà più occasioni di soddisfarne i criteri nell'arco della settimana.",
    cues: [
      "Supino, piedi a terra vicino ai glutei, larghezza dei fianchi",
      "Spingi dai talloni",
      "Solleva il bacino finché il corpo è in linea",
      "Stringi i glutei in cima 2 secondi, poi scendi lento",
    ],
    errors: [
      "Inarcare la schiena per salire più in alto",
      "Spingere dalle punte",
      "Salire a strappo",
      "Non stringere i glutei",
    ],
    criteria: {
      pain: "Nessun fastidio lombare durante o dopo; la spinta si sente nei glutei, non nella schiena.",
      control: "8 ripetizioni con 2 secondi di tenuta in alto, bacino stabile e a livello.",
      quality: "Corpo in linea retta (no iperestensione), spinta dai talloni, glutei attivi, nessun compenso lombare.",
    },
    images: ["/exercises/glute-bridge-1.jpg", "/exercises/glute-bridge-2.jpg"],
  }),
  exm("Wall slide scapolare", 2, 8, null, {
    keyId: "wallslide",
    desc: "Anche le scapole ripagano la frequenza: torna in B per consolidare il controllo della parte alta e darti la seconda occasione settimanale di superarne i criteri.",
    cues: [
      "In piedi con schiena, bacino e testa appoggiati al muro; i PIEDI stanno a circa 15-20 cm dalla parete, leggermente in avanti",
      "Piega leggermente le ginocchia e appiattisci la zona lombare contro il muro (non deve restare spazio dietro la schiena bassa)",
      "Porta le braccia contro il muro a formare una W: dorso delle mani e gomiti a contatto con la parete",
      "Fai scivolare le braccia verso l'alto fino a una Y, mantenendo mani e gomiti attaccati al muro",
      "Torna giù lento, controllando il movimento",
    ],
    errors: [
      "La schiena bassa che si stacca dal muro e si inarca per far salire le braccia",
      "Gomiti o polsi che perdono il contatto col muro",
      "Spalle che salgono verso le orecchie",
      "Forzare l'altezza sacrificando il contatto",
    ],
    criteria: {
      pain: "Nessun dolore o impingement alla spalla; lavoro percepito tra le scapole.",
      control: "8 ripetizioni mantenendo mani, gomiti e lombare in contatto col muro.",
      quality: "Schiena bassa piatta sul muro, contatto delle braccia mantenuto, spalle basse, movimento simmetrico.",
    },
  }),
];

// ---------------------------------------------------------------------------
// Mobilità & Rinforzo — Stadio 2 (mastery path)
// ---------------------------------------------------------------------------
const MR_L2_A = [
  exm("Respirazione 90/90", 2, 5, null, {
    desc: "Carry-over dallo Stadio 1, qui come reset rapido a inizio sessione. Riporta il bacino in posizione neutra e calma la lombare prima di caricare le gambe.",
    cues: [
      "Supino, polpacci su una sedia, fianchi e ginocchia a 90°",
      "Lombare appoggiata a terra",
      "Inspira in pancia, espira lungo sentendo le costole scendere",
      "Niente fretta, sono solo 5 respiri",
    ],
    errors: [
      "Saltarlo perché \"tanto lo so fare\" (serve a impostare il tono)",
      "Respirare di petto",
      "Inarcare la lombare",
    ],
  }),
  exm("Mobilità anca 90/90 attiva", 2, 6, null, {
    desc: "Evoluzione della mobilità d'anca dello Stadio 1: ora la rotazione la guidi col muscolo, non la subisci passivamente. Prepara le anche ad aprirsi nello squat e costruisce controllo attivo nelle posizioni estreme. (6 rotazioni per lato)",
    cues: [
      "Seduto a terra, gambe a Z (una davanti, una di lato, entrambe 90°)",
      "Busto eretto",
      "Ruota attivamente entrambe le ginocchia da un lato all'altro, controllando andata e ritorno",
      "Pausa di un secondo nei due estremi, petto sempre alto",
    ],
    errors: [
      "Lasciarsi cadere passivamente invece di controllare il movimento",
      "Arrotondare la schiena per guadagnare range",
      "Sollevare il bacino",
      "Andare a strappi",
    ],
  }),
  exm("Squat a profondità progressiva", 3, 6, null, {
    keyId: "squat",
    desc: "Il cuore dello stadio. L'obiettivo NON è uno squat profondo da subito: è scendere ogni settimana un po' più di prima, mantenendo schiena neutra e talloni a terra. La profondità si guadagna, non si pretende. Usa un appoggio (stipite, maniglia, tavolo) per scaricare un po' di peso finché ne hai bisogno: è una tappa, non un fallimento.",
    cues: [
      "Piedi a larghezza spalle, punte leggermente in fuori",
      "Se serve, tieni un appoggio davanti con le mani",
      "Scendi mandando il bacino indietro e in basso insieme, ginocchia che seguono le punte",
      "Scendi fin dove la schiena resta neutra e i talloni restano a terra, non oltre; risali dai talloni",
    ],
    errors: [
      "Forzare la profondità arrotondando la schiena o staccando i talloni (è il limite da rispettare, non da superare a forza)",
      "Ginocchia che collassano verso l'interno",
      "Scendere a peso morto invece che controllando",
      "Paragonarsi alla profondità di altri invece che alla propria di prima",
    ],
    criteria: {
      pain: "Nessun dolore a ginocchia, anche o schiena durante e dopo; senti lavoro muscolare e allungamento, non fastidio articolare.",
      control: "Scendo più in basso rispetto alle settimane scorse mantenendo schiena neutra e talloni a terra (auto-valutazione del tuo progresso, non di una soglia fissa), per 6 ripetizioni controllate.",
      quality: "Schiena neutra a ogni ripetizione, talloni piantati, ginocchia allineate con le punte, discesa e risalita controllate senza rimbalzi.",
    },
  }),
  exm("Split squat statico", 3, 6, null, {
    keyId: "splitsquat",
    desc: "L'ingresso nel lavoro a una gamba, ma con entrambi i piedi a terra: richiede meno equilibrio di un affondo camminato e ti lascia concentrare sul controllo. Ponte verso il monopodalico vero e smaschera gli squilibri tra destra e sinistra. (6 ripetizioni per gamba)",
    cues: [
      "Passo avanti, piedi come su due binari (non in equilibrio su una linea)",
      "Busto eretto, peso distribuito tra i due piedi",
      "Scendi dritto in basso piegando entrambe le ginocchia, quello davanti sopra il piede",
      "Il ginocchio dietro va verso il pavimento senza toccarlo; risali spingendo dal tallone davanti",
    ],
    errors: [
      "Sbilanciarsi in avanti caricando solo la gamba davanti",
      "Ginocchio davanti che cade verso l'interno",
      "Busto che si piega in avanti",
      "Fare meno ripetizioni sul lato debole (anzi, è quello che ha più bisogno)",
    ],
    criteria: {
      pain: "Nessun dolore alle ginocchia o all'anca; lavoro sentito nei muscoli della coscia e del gluteo.",
      control: "6 ripetizioni controllate per gamba, busto stabile ed eretto, senza cercare appoggi per l'equilibrio.",
      quality: "Discesa verticale (non in avanti), ginocchio davanti allineato col piede, stessa qualità su entrambi i lati, risalita dal tallone.",
    },
  }),
  exm("Deep squat hold in appoggio", 2, null, 30, {
    desc: "Accovacciata profonda tenendo un appoggio, per aprire passivamente anca e caviglia nella posizione di fondo. Mentre lo squat chiave lavora il range attivo, questo lavora il range passivo: stare comodo in fondo allo squat è ciò che, col tempo, rende profondo lo squat attivo.",
    cues: [
      "Tieni un appoggio davanti (maniglia, stipite)",
      "Scendi in accovacciata il più in basso che riesci comodamente, talloni a terra",
      "Usa i gomiti per spingere dolcemente le ginocchia in fuori",
      "Respira e rilassati nella posizione; se i talloni si alzano, mettici sotto un piccolo rialzo",
    ],
    errors: [
      "Talloni che si staccano (usa un rialzo)",
      "Trattenere il respiro e irrigidirsi invece di rilassare",
      "Rimbalzare cercando di andare più giù a forza",
      "Tenere la schiena completamente curva sotto tensione",
    ],
  }),
  exm("Mobilità toracica \"libro aperto\"", 2, 6, null, {
    desc: "Rotazione del tratto dorsale, sostituisce l'hang dello Stadio 1 ora che restiamo a corpo libero. Sblocca la zona che la postura da scrivania irrigidisce di più e libera le spalle senza una sbarra. (6 ripetizioni per lato)",
    cues: [
      "Sdraiato su un fianco, ginocchia piegate davanti a 90°, braccia tese unite davanti",
      "Apri il braccio di sopra ruotando il busto verso il lato opposto, segui la mano con lo sguardo",
      "Le ginocchia restano ferme a terra",
      "Vai fin dove senti aprire il petto, respira, poi torna",
    ],
    errors: [
      "Lasciar staccare le ginocchia per ruotare di più (il movimento viene dalla schiena alta, non dal bacino)",
      "Forzare con strappi",
      "Tenere il respiro bloccato",
      "Ruotare il collo invece del torace",
    ],
  }),
];

const MR_L2_B = [
  exm("Respirazione diaframmatica", 2, 5, null, {
    desc: "Reset iniziale da supino classico. Un minuto per impostare respiro e pressione del core prima del lavoro su una gamba, dove la stabilità centrale conta ancora di più.",
    cues: [
      "Supino, ginocchia piegate",
      "Mano sulla pancia che si alza, mano sul petto ferma",
      "Inspira dal naso, espira lungo dalla bocca",
      "4 secondi dentro, 6 fuori",
    ],
    errors: [
      "Respirare di petto",
      "Trattenere il fiato",
      "Irrigidire collo e spalle",
    ],
  }),
  exm("Cossack assistito", 2, 5, null, {
    desc: "Affondo laterale profondo tenendo un appoggio: apre l'anca sul piano laterale, una direzione che squat e affondi frontali non toccano. Costruisce la mobilità d'anca \"larga\" che serve per scendere comodi nello squat e protegge inguine e adduttori. (5 ripetizioni per lato)",
    cues: [
      "Tieni un appoggio davanti, piedi molto larghi",
      "Sposta il peso su una gamba piegandola, l'altra resta tesa con la punta che può alzarsi",
      "Scendi di lato tenendo il tallone della gamba piegata a terra",
      "Petto alto, schiena dritta; risali e passa all'altro lato",
    ],
    errors: [
      "Tallone della gamba piegata che si stacca",
      "Schiena che si arrotonda in basso",
      "Scendere a strappo invece che controllato",
      "Andare più giù di quanto l'anca permetta comodamente",
    ],
  }),
  exm("Hip hinge monopodalico assistito", 3, 5, null, {
    keyId: "slhinge",
    desc: "La progressione diretta dell'hip hinge dello Stadio 1, ora su una gamba sola — il salto che insegna a stabilizzare anca e bacino in modo indipendente. L'appoggio di un dito serve solo per l'equilibrio, non per scaricare il peso. Salda lo Stadio 1 allo Stadio 2. (5 ripetizioni per gamba)",
    cues: [
      "In piedi su una gamba, l'altra leggermente sollevata dietro",
      "Una mano sfiora un appoggio solo per l'equilibrio",
      "Manda il bacino indietro inclinando il busto in avanti, la gamba libera si estende dietro come contrappeso (movimento ad altalena)",
      "Schiena dritta come un'asse; senti l'allungamento dietro la coscia d'appoggio, poi risali stringendo il gluteo",
    ],
    errors: [
      "Appoggiarsi col braccio per scaricare il peso invece di usarlo solo per l'equilibrio",
      "Arrotondare la schiena (stesso limite invalicabile dell'hip hinge base)",
      "Ruotare il bacino di lato invece di tenerlo a livello verso il pavimento",
      "Piegare il ginocchio d'appoggio come in uno squat invece di mandare l'anca indietro",
    ],
    criteria: {
      pain: "Nessun dolore lombare o all'anca d'appoggio; allungamento sentito dietro la coscia, non fastidio nella schiena.",
      control: "5 ripetizioni per gamba con un solo dito d'appoggio per l'equilibrio, bacino che resta a livello, senza scaricare il peso sul braccio.",
      quality: "Schiena neutra per tutta l'esecuzione, movimento che parte dall'anca, bacino non ruotato, risalita controllata con i glutei.",
    },
  }),
  exm("Squat a profondità progressiva", 3, 6, null, {
    keyId: "squat",
    desc: "Ritorna in Sessione B per frequenza: il range nello squat ripaga la ripetizione e ti dà la seconda occasione settimanale di soddisfarne i criteri. Stesso principio — più giù di prima, con esecuzione pulita.",
    cues: [
      "Piedi a larghezza spalle, punte un po' in fuori",
      "Appoggio davanti se serve",
      "Scendi mandando il bacino indietro e in basso, ginocchia verso le punte",
      "Fin dove schiena resta neutra e talloni a terra; risali dai talloni",
    ],
    errors: [
      "Forzare la profondità arrotondando o staccando i talloni",
      "Ginocchia che collassano dentro",
      "Scendere a peso morto",
      "Inseguire la profondità di altri",
    ],
    criteria: {
      pain: "Nessun dolore a ginocchia, anche o schiena durante e dopo; senti lavoro muscolare e allungamento, non fastidio articolare.",
      control: "Scendo più in basso rispetto alle settimane scorse mantenendo schiena neutra e talloni a terra (auto-valutazione del tuo progresso, non di una soglia fissa), per 6 ripetizioni controllate.",
      quality: "Schiena neutra a ogni ripetizione, talloni piantati, ginocchia allineate con le punte, discesa e risalita controllate senza rimbalzi.",
    },
  }),
  exm("Split squat statico", 3, 6, null, {
    keyId: "splitsquat",
    desc: "Anche lo split squat torna in B per consolidare il controllo monopodalico e darti la seconda occasione settimanale di superarne i criteri. Insieme all'hip hinge a una gamba, completa il lavoro unilaterale dello stadio. (6 ripetizioni per gamba)",
    cues: [
      "Piedi su due binari, busto eretto",
      "Scendi dritto piegando entrambe le ginocchia, quello davanti sopra il piede",
      "Ginocchio dietro verso il pavimento senza toccare",
      "Risali dal tallone davanti",
    ],
    errors: [
      "Sbilanciarsi in avanti",
      "Ginocchio davanti che cade dentro",
      "Busto piegato in avanti",
      "Trascurare il lato debole",
    ],
    criteria: {
      pain: "Nessun dolore alle ginocchia o all'anca; lavoro sentito nei muscoli della coscia e del gluteo.",
      control: "6 ripetizioni controllate per gamba, busto stabile ed eretto, senza cercare appoggi per l'equilibrio.",
      quality: "Discesa verticale (non in avanti), ginocchio davanti allineato col piede, stessa qualità su entrambi i lati, risalita dal tallone.",
    },
  }),
  exm("Dead bug avanzato", 3, 6, null, {
    keyId: "deadbugadv",
    desc: "Il gradino sopra il dead bug dello Stadio 1: stessa logica anti-estensione (lombare a terra mentre gli arti si muovono), ma con range più ampio ed estensione più lenta, che alza la richiesta di controllo del core. (6 ripetizioni per lato)",
    cues: [
      "Supino, braccia verso il soffitto, fianchi e ginocchia a 90°",
      "Lombare schiacciata a terra per tutta la durata",
      "Estendi braccio e gamba opposti più lentamente e più lunghi di prima, fin quasi a toccare il pavimento",
      "Pausa di un secondo da esteso, torna controllato e alterna",
    ],
    errors: [
      "La schiena che si stacca e si inarca (il limite di sempre: se succede, riduci il range)",
      "Accelerare l'estensione perdendo il controllo",
      "Trattenere il respiro",
      "Estendere così tanto da non riuscire a tenere la lombare a terra",
    ],
    criteria: {
      pain: "Zero dolore lombare; la fatica si sente nell'addome profondo.",
      control: "6 ripetizioni per lato con estensione lenta e lombare aderente a terra per tutta la serie.",
      quality: "Schiena che non si inarca mai, estensione lenta e controllata, pausa da esteso, respiro continuo.",
    },
  }),
];

const MOBILITA_RINFORZO = {
  id: "mobilita-rinforzo",
  name: "Mobilità & Rinforzo",
  progressionType: "mastery",
  phases: [
    {
      id: "mr-l1",
      name: "Stadio 1 — Riattivazione",
      subtitle: "Il punto di partenza",
      tag: "Inizia qui",
      weeks: [
        {
          id: "mr-l1-w1",
          name: "Sessioni",
          days: [
            { type: "training", id: "mr-l1-a", dayNum: 1, weekday: null, label: "Sessione A", subtitle: "Controllo & catena posteriore", exercises: MR_L1_A },
            { type: "training", id: "mr-l1-b", dayNum: 2, weekday: null, label: "Sessione B", subtitle: "Pattern & anca", exercises: MR_L1_B },
          ],
        },
      ],
    },
    {
      id: "mr-l2",
      name: "Stadio 2 — Range & Squat",
      subtitle: "Range pieno e monopodalico",
      tag: "Intermedio",
      weeks: [
        {
          id: "mr-l2-w1",
          name: "Sessioni",
          days: [
            { type: "training", id: "mr-l2-a", dayNum: 1, weekday: null, label: "Sessione A", subtitle: "Squat e catena inferiore", exercises: MR_L2_A },
            { type: "training", id: "mr-l2-b", dayNum: 2, weekday: null, label: "Sessione B", subtitle: "Pattern monopodalico e core", exercises: MR_L2_B },
          ],
        },
      ],
    },
  ],
};

export const PROGRAMS = [CALIMOVE, MOBILITA_RINFORZO];

export function getProgram(id) {
  return PROGRAMS.find((p) => p.id === id) || null;
}

// Backwards-compatibility alias (Cali Move is the first program)
export const PROGRAM = CALIMOVE;

// Active program selection — stored locally, no backend changes
const ACTIVE_KEY = "cm_active_program";
export function isProgramVisible(program, userEmail) {
  if (!program.private) return true;
  if (!userEmail) return false;
  return program.allowedEmails.some(
    (e) => e.toLowerCase() === userEmail.toLowerCase()
  );
}

export function getActiveProgramId() {
  return localStorage.getItem(ACTIVE_KEY);
}
export function setActiveProgramId(id) {
  localStorage.setItem(ACTIVE_KEY, id);
}
export function clearActiveProgramId() {
  localStorage.removeItem(ACTIVE_KEY);
}

// ---------------------------------------------------------------------------
// Helpers
// ---------------------------------------------------------------------------
export function exText(e) {
  const parts = [];
  if (e.reps != null) parts.push(`${e.sets} set × ${e.reps} reps`);
  else parts.push(`${e.sets} set`);
  if (e.hold != null) parts.push(`${e.hold}s tenuta`);
  return parts.join("  ·  ");
}

export function itemId(dayId, idx) {
  return `${dayId}-${idx}`;
}

// All training days flattened in program order (phases + bonus)
export function allTrainingDays(program) {
  const out = [];
  (program?.phases || []).forEach((phase) => {
    phase.weeks.forEach((week) => {
      week.days.forEach((day) => {
        if (day.type === "training") out.push({ ...day, phase, week });
      });
    });
  });
  return out;
}

export function findDay(program, dayId) {
  for (const phase of program?.phases || []) {
    for (const week of phase.weeks) {
      for (const day of week.days) {
        if (day.type === "training" && day.id === dayId)
          return { ...day, phase, week };
      }
    }
  }
  for (const b of program?.bonus || []) {
    if (b.id === dayId)
      return {
        ...b,
        id: b.id,
        label: b.name,
        exercises: b.exercises,
        phase: { id: "bonus", name: "Obiettivi" },
        week: { name: b.desc },
        isBonus: true,
      };
  }
  return null;
}

export function dayCompletion(day, completedSet) {
  const total = day.exercises.length;
  let done = 0;
  day.exercises.forEach((_, i) => {
    if (completedSet.has(itemId(day.id, i))) done += 1;
  });
  return { done, total, pct: total ? Math.round((done / total) * 100) : 0 };
}

export function isDayComplete(day, completedSet) {
  return day.exercises.every((_, i) => completedSet.has(itemId(day.id, i)));
}

// Returns the first not-fully-completed training day (the "today" workout)
export function nextSession(program, completedSet) {
  const days = allTrainingDays(program);
  for (const d of days) {
    if (!isDayComplete(d, completedSet)) return d;
  }
  return days[days.length - 1] || null;
}

// For mastery programs: returns the current phase's A or B session based on the A/B pointer.
// Finds sessions by id suffix ("-a" / "-b") to avoid relying on array order.
export function masteryNextSession(program, completedSet) {
  const phases = program?.phases || [];
  // Most advanced unlocked phase
  let currentPhaseIdx = 0;
  for (let i = 0; i < phases.length; i++) {
    if (isPhaseUnlocked(program, i, completedSet)) currentPhaseIdx = i;
  }
  const phase = phases[currentPhaseIdx];
  const trainingDays = [];
  phase.weeks.forEach((week) =>
    week.days.forEach((day) => {
      if (day.type === "training") trainingDays.push({ ...day, phase, week });
    })
  );
  const dayA = trainingDays.find((d) => d.id.endsWith("-a"));
  const dayB = trainingDays.find((d) => d.id.endsWith("-b"));
  const nextIsB = completedSet.has(`${phase.id}-next-b`);
  return nextIsB ? (dayB ?? dayA) : (dayA ?? dayB);
}

// For mastery programs: padronanza progress of the current (most advanced unlocked) phase.
export function masteryStadioProgress(program, completedSet) {
  const phases = program?.phases || [];
  let currentPhaseIdx = 0;
  for (let i = 0; i < phases.length; i++) {
    if (isPhaseUnlocked(program, i, completedSet)) currentPhaseIdx = i;
  }
  const phase = phases[currentPhaseIdx];
  const { done, total } = phaseMasteryCount(phase, completedSet);
  return { phase, done, total, pct: total ? Math.round((done / total) * 100) : 0 };
}

export function overallStats(program, completedSet) {
  const days = allTrainingDays(program);
  let totalEx = 0;
  let doneEx = 0;
  let doneDays = 0;
  days.forEach((d) => {
    totalEx += d.exercises.length;
    const c = dayCompletion(d, completedSet);
    doneEx += c.done;
    if (c.done === c.total) doneDays += 1;
  });
  return {
    totalDays: days.length,
    doneDays,
    totalEx,
    doneEx,
    pct: totalEx ? Math.round((doneEx / totalEx) * 100) : 0,
  };
}

// ---------------------------------------------------------------------------
// Mastery gate (unlock logic) — frontend-only, based on saved criteria item_ids
// ---------------------------------------------------------------------------
export function phaseKeyMovements(phase) {
  const set = new Set();
  (phase.weeks || []).forEach((w) =>
    (w.days || []).forEach((d) => {
      if (d.type === "training")
        (d.exercises || []).forEach((e) => {
          if (e.keyId) set.add(e.keyId);
        });
    })
  );
  return [...set];
}

export function isMovementMastered(levelId, keyId, completedSet) {
  return ["pain", "control", "quality"].every((c) =>
    completedSet.has(`${levelId}-${keyId}-${c}`)
  );
}

export function phaseMasteryCount(phase, completedSet) {
  const keys = phaseKeyMovements(phase);
  const done = keys.filter((k) => isMovementMastered(phase.id, k, completedSet)).length;
  return { done, total: keys.length };
}

export function isPhaseMastered(phase, completedSet) {
  const { done, total } = phaseMasteryCount(phase, completedSet);
  return total > 0 && done === total;
}

// First phase always unlocked; each next phase needs the previous one mastered.
// Non-mastery programs (Cali Move) are always unlocked.
export function isPhaseUnlocked(program, phaseIndex, completedSet) {
  if (!program || program.progressionType !== "mastery") return true;
  if (phaseIndex <= 0) return true;
  return isPhaseMastered(program.phases[phaseIndex - 1], completedSet);
}
